import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';

function checkPlannerLimit({
  schoolyearId,
  schoolId,
}: {
  schoolyearId: string;
  schoolId: string;
}) {
  const requestURL = `${
    import.meta.env.VITE_API_URL
  }/schoolyears/${schoolyearId}/schools/${schoolId}/reunion-categories/check-limit`;
  return request(requestURL, {
    method: 'GET',
  });
}

export function useCheckPlannerLimit() {
  const { schoolyear, school } = useSchoolSchoolyear();
  return () =>
    checkPlannerLimit({ schoolyearId: schoolyear.id, schoolId: school.id });
}
